import React from 'react';
import { LocationButtonAmountMode, SaleLocationStatusDTO } from 'core/api';
import * as UI from 'core/ui';
import * as Images from '../Images';
import { Colors } from 'core/ui';

const formatMoney = UI.Format.asMoney;

type Props = {
	location: SaleLocationStatusDTO & { Style: { Text: string; ImageId: string; BackColor: string } };
	onValueSelected: (value: SaleLocationStatusDTO) => void;
}

type StyleWithVars = React.CSSProperties & Record<`--${string}`, string>;

function getButtonStateClass(location: SaleLocationStatusDTO, isRefundMoney: boolean) {
	if (location.IsInactive) return 'btn-sale-location-inactive';
	if (isRefundMoney) return 'btn-sale-location-refund';
	return '';
}

export function SaleLocationButton({ location, onValueSelected }: Props) {

	const isRefundMoney = location.AmountMode === LocationButtonAmountMode.Balance && location.Amount < 0;
	const buttonStateClass = getButtonStateClass(location, isRefundMoney);

	const preparedIcon = location.TicketHasBeenPrepared ?
		<span className='btn-sale-location-badge btn-sale-location-badge-success'>
			<Images.ServePlate className='btn-sale-location-badge-icon' aria-hidden='true' focusable='false' />
		</span> : null;

	const printIcon = location.TicketHasBeenPresented ?
		<span className='btn-sale-location-badge btn-sale-location-badge-info'>
			<Images.PrintTicket className='btn-sale-location-badge-icon' aria-hidden='true' focusable='false' />
		</span> : null;

	const inactiveIcon = location.IsInactive ?
		<span className='btn-sale-location-badge btn-sale-location-badge-error'>
			<Images.Clock className='btn-sale-location-badge-icon' aria-hidden='true' focusable='false' />
		</span> : null;

	const tableCompanions = location.TableCompanions ?
		<span className='btn-sale-location-companions'>
			<Images.User className='btn-sale-location-companions-icon' aria-hidden='true' focusable='false' />
			{location.TableCompanions}
		</span> : null;

	const locationName = <span className='btn-sale-location-title'>{location.DisplayName}</span>;
	const balanceIcon = isRefundMoney ? <Images.RefundMoney className='btn-sale-location-amount-icon' aria-hidden='true' focusable='false' /> : null;
	const amount = location.HasOpenedTickets ?
		<span className={isRefundMoney ? 'btn-sale-location-amount btn-sale-location-amount-refund' : 'btn-sale-location-amount'}>
			{balanceIcon}
			{formatMoney(location.Amount)}
		</span> : null;

	const backgroundColor = Colors.getBackgroundColorAsRgb(location.Style.BackColor);
	const buttonStyle: StyleWithVars = {
		backgroundColor,
		color: Colors.getTextColor(backgroundColor)
	};

	return <button
		type='button'
		className={buttonStateClass ? `btn-sale-location ${buttonStateClass}` : 'btn-sale-location'}
		style={buttonStyle}
		onClick={() => onValueSelected(location)}
	>
		<span className='btn-sale-location-badges'>
			{preparedIcon}
			{printIcon}
			{inactiveIcon}
		</span>

		<span className='btn-sale-location-content'>
			{locationName}
			{amount}
			{tableCompanions}
		</span>
	</button>;
}
